import { BannerLayout, MainLayout } from "@/layouts"
import careerBanner from "@/assets/images/banner/career_banner.png"
import { ROUTER_NAMES } from "@/constants/router.constants"

const LeagueOfLegendsImageBackground =
  "https://d1ni87qrzj7kv2.cloudfront.net/eyJidWNrZXQiOiJwcm9ndWlkZXMtYXNzZXRzIiwia2V5IjoiYXNzZXRzL2dhbWVzL2xlYWd1ZW9mbGVnZW5kcy9nYW1lLWJhbm5lcl9iYWNrZ3JvdW5kLnBuZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MTkyMCwiaGVpZ2h0IjoyNzksImZpdCI6ImNvdmVyIn19fQ=="
const LeagueOfLegendsImageForeground =
  "https://d1ni87qrzj7kv2.cloudfront.net/eyJidWNrZXQiOiJwcm9ndWlkZXMtYXNzZXRzIiwia2V5IjoiYXNzZXRzL2dhbWVzL2xlYWd1ZW9mbGVnZW5kcy9nYW1lLWJhbm5lcl9mb3JlZ3JvdW5kLnBuZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6ODk1LCJoZWlnaHQiOjMwMiwiZml0IjoiY292ZXIifX19"

const Career = () =>
  import(/* webpackChunkName: "company" */ "@/pages/Career.vue")
const Privacy = () =>
  import(/* webpackChunkName: "company" */ "@/pages/Privacy.vue")
const TermsAndCondition = () =>
  import(/* webpackChunkName: "company" */ "@/pages/TermsAndCondition.vue")
const InstacoachTermsConditions = () =>
  import(
    /* webpackChunkName: "company" */ "@/pages/instacoach/TermsConditions"
  )

export default [
  {
    path: "/careers",
    name: ROUTER_NAMES.CAREERS,
    component: Career,
    meta: {
      layout: {
        component: MainLayout,
        child: {
          component: BannerLayout,
          props: {
            bannerImageBackground: careerBanner,
          },
        },
      },
    },
  },
  {
    path: "/privacy_policy",
    name: ROUTER_NAMES.PRIVACY,
    component: Privacy,
    meta: {
      layout: {
        component: MainLayout,
        child: {
          component: BannerLayout,
          props: {
            bannerImageBackground: LeagueOfLegendsImageBackground,
            bannerImageForeground: LeagueOfLegendsImageForeground,
          },
        },
      },
    },
  },
  {
    path: "/terms_and_conditions",
    name: ROUTER_NAMES.TERMS,
    component: TermsAndCondition,
    meta: {
      layout: {
        component: MainLayout,
        child: {
          component: BannerLayout,
          props: {
            bannerImageBackground: LeagueOfLegendsImageBackground,
            bannerImageForeground: LeagueOfLegendsImageForeground,
          },
        },
      },
    },
  },
  {
    path: "/instapro/terms_and_conditions",
    name: ROUTER_NAMES.COACH_TERMS,
    component: InstacoachTermsConditions,
    meta: {
      layout: {
        component: MainLayout,
        child: {
          component: BannerLayout,
          props: {
            bannerImageBackground: LeagueOfLegendsImageBackground,
            bannerImageForeground: LeagueOfLegendsImageForeground,
          },
        },
      },
    },
  },
]



// WEBPACK FOOTER //
// ./src/router/company.routes.js